import React, { Component, Dispatch } from 'react';
import ApiClient from '../../../api/alms-api';
import Translator from '../../../core/i18n';
import * as Actions from '../../../store/actions/coursePage';
import { Log } from 'ng2-logger';
import CActivityProgress from '../activity-progress/main';
import ClassSelection from '../class-selection/main';
import { IHeaderProps } from '../../../models/components/lesson-header';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import ScrollableMenu from '../../scrolableMenu/ScrollableMenu'
import {
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledButtonDropdown,
    UncontrolledCollapse,
    UncontrolledPopover,
    PopoverBody
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import Loading from '../../loading/loading';
import { UserType } from '../../../models/pages/login.d';
import { Common } from '../../../core/common';
import { TabMenuItems } from '../../../models/components/lesson-menu-tab';
import { SecureImage } from '../../core/secureImage';
import queryString from 'querystring';

import Moment from 'moment';
import { CourseContentMenuType } from '../../../models/enums/CourseContentMenuType';
import ICourseContentMenu from '../../../models/components/course-content-menu';
import { getMainMenuData } from '../../../store/actions/mainMenu';
import { IActivityFilters } from '../../../models/action/coursePage';
import { IActivityCard } from '../../../models/components/activity-card';
import Truncate from 'react-truncate';
import { CourseDefaultViewType } from '../../../models/enums/CourseDefaultViewType';
import ReactGA from 'react-ga4';
import Tooltip from '../../tooltip/main';
import Truncater from '../../truncater/main';
import { ModuleItems } from '../../../models/enums/moduleItems';

const T = Translator.create();
const _logger = Log.create('lessonPage-header.tsx');
const token: any = localStorage.getItem('access_token');
let _common: Common;
const CourseLogo = `${process.env.PUBLIC_URL}/images/constructor/course_logo.png`;

class LessonPageHeader extends React.Component<ICourseContentMenu, any> {
    public courseNavigationn: HTMLDivElement | null = null;
    public formm: HTMLFormElement | null = null;
    static contextType = VisibilityContext;

    state = { currentWeekTrackingGuid: '', currentWeek: 0, showMobile: false, active: 0 };

    constructor(props: any) {
        super(props);
        _common = new Common();
    }
    public componentDidMount = () => {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        if (this.props.coursePageClassId) {
            this.dispatchCourseInformation(this.props.coursePageClassId, this.props.coursePageActivityId!);
        }

        let search = window.location.search;
        search = search.replace('?', '');
        const params = queryString.parse(search);
        if (params?.weekorunitid) {
            if(this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 0){
                const findWeek = this.props.courseContentTermWeeks.find(x => x.termWeekId === params.weekorunitid);
                if (findWeek) {
                    this.setState({ currentWeekTrackingGuid: params.weekorunitid, currentWeek: findWeek.week });
                }
            }

        }


    };

    componentDidUpdate(prevProps: Readonly<ICourseContentMenu>, prevState: Readonly<any>, snapshot?: any): void {
        this.refreshCourseContent();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    refreshCourseContent = () => {
        if(!this.props.courseContentMenuType){
            this.props.dispatch(Actions.getCourseContentMenu(this.props.coursePageClassId!, this.props.coursePageActivityId ?? "", this.props.weekOrUnitId ?? "0", false, 'getCourseContentMenu', 'get'));

        }
    }

    handleResize = () => {
        if (window.innerWidth > 768) {
            this.setState({ showMobile: false });
        } else {
            this.setState({ showMobile: true });
        }
    };

    public componentWillReceiveProps(nextProps: IHeaderProps, prevProps: IHeaderProps) {
        if (nextProps.coursePageClassId !== this.props.coursePageClassId) {
            this.dispatchCourseInformation(nextProps.coursePageClassId!, nextProps.coursePageActivityId!);
        }
    }

    public dispatchCourseInformation = (classId: string, activityId: string) => {
        this.props.dispatch(Actions.getCoursePageHeaderInformationData(classId, activityId, 'getCoursePageHeaderInformationData', 'get',
            () => {
                this.props.dispatch(Actions.getCourseContentMenu(classId, activityId ?? "", '', false, 'getCourseContentMenu', 'get',
                    this.getActivityIdsByWeeks()));
            }));
    };

    public getActivityIdsByWeeks = () => {
        this.props.dispatch(Actions.getActivityIdsByWeeks(this.props.coursePageClassId!, '', false, 'getActivityIdsByWeeks', 'get', undefined, false, this.props.coursePageActivityId ?? ""));
    }

    public courseImageOnError = (event: any) => {
        if (event) {
            event.target.src = _common.GetDefaultLogos('course');
        }
    };
    public tabOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (event) {

            const getMenuParam = event.currentTarget.dataset.tabparam;

            let actionName = '';

            if (getMenuParam == "1") {
                actionName = 'G_MENU_COURCE_CONTENT_CLICKED';
            }
            else if (getMenuParam == "4") {
                actionName = 'G_MENU_ANNOUNCEMENT_CLICKED';
            }
            else if (getMenuParam == "5") {
                actionName = 'G_MENU_FORUM_CLICKED';
            }
            else if (getMenuParam == "6") {
                actionName = 'G_MENU_FILES_CLICKED';
            }
            else if (getMenuParam == "7") {
                actionName = 'G_MENU_STUDENT_LIST_CLICKED';
            }
            else if (getMenuParam == "8") {
                actionName = 'G_MENU_OPERATIONS_CLICKED';
            }

            if (actionName != '') {
                ReactGA.event({
                    category: window.location.host,
                    action: actionName,
                    label: actionName,
                    nonInteraction: true,
                });
            }
            this.props.dispatch(Actions.getCoursePageSelectedTab((getMenuParam) ? getMenuParam : '0'));
            this.setState(() => ({ activeTabType: getMenuParam, redirect: true }));
        }
    };
    public getUiMonth = (startDate: Date, endDate: Date): string => {
        const getStartDay = new Date(startDate).getDate().toString();
        const getEndDay = new Date(endDate).getDate().toString();
        const getStartYear = new Date(startDate).getFullYear();
        const getEndYear = new Date(endDate).getFullYear();
        const getStartMonth = new Date(startDate).getMonth();
        const getEndMonth = new Date(endDate).getMonth();
        // tslint:disable-next-line:one-variable-per-declaration
        let startDay = '', endDay = '', startMonth = '', endMonth = '', startYear = '', endYear = '';
        startDay = getStartDay;
        endDay = getEndDay;
        if (getStartYear === getEndYear) {
            startYear = getStartYear.toString();
        } else {
            startYear = getStartYear + '';
            endYear = getEndYear.toString();
        }
        if (getStartMonth === getEndMonth) {
            startMonth = T.t(_common.GetMonthText(getStartMonth));
        } else {
            startMonth = T.t(_common.GetMonthText(getStartMonth));
            endMonth = T.t(_common.GetMonthText(getEndMonth));
        }
        let result = startDay;
        result += (endMonth === '') ? '' : ' ' + startMonth;
        result += (endYear === '') ? '' : ' ' + startYear;
        result += '-' + endDay + ' ';
        result += (endMonth === '') ? startMonth + ' ' : ' ' + endMonth + ' ';
        result += (endYear === '') ? startYear + ' ' : ' ' + endYear + ' ';
        return result;
    }

    public weekOnClick = (event?: React.MouseEvent<HTMLDivElement>, itemKeyRef?: string, weekIdRef?: string) => {
        const itemKey = (event && event.currentTarget.dataset.itemkey) ? event.currentTarget.dataset.itemkey.toString() : itemKeyRef ? itemKeyRef : '';
        const weekid = (event && event.currentTarget.dataset.weekid) ? event.currentTarget.dataset.weekid.toString() : weekIdRef ? weekIdRef : '';

        const findWeek = this.props.courseContentTermWeeks!.find(x => x.termWeekId === weekid);


        this.setState({ currentWeekTrackingGuid: weekid, currentWeek: findWeek!.week });

        this.props.dispatch(Actions.SetTriggerWeekOnClick(itemKey,
            this.props.coursePageclassInformation && this.props.coursePageclassInformation.courseDefaultView === CourseDefaultViewType.List ? '-1' : weekid,
            this.props.courseContentMenuType!,
            this.props.activeTabGuid!,
            this.props.courseContentTermWeeks!,
            this.props.hasFilter,
            this.props.coursePageClassId!,
            this.props.coursePageActivityId!,
            this.props.sort!,
            this.props.activityFilters,
            this.props.courseContentWeeksActivities,
            this.props.coursePageclassInformation.courseDefaultView,
        ));
    }

    public onChangeWeek = (event: any) => {
        // _logger.data('OnChange Week', event);
    }
    public render() {
        return (
            <div id="header" style={{ borderBottom: ' 2px solid #908f8d',position: 'fixed',top: '72px !important',zIndex: '1',width: '100%' }}>

                <div className="lesson-header">
                    <div style={{ width: '100%' }} >

                        <div className="row d-flex p-2 mr-0 align-items-center">
                            <div className="col-md-3 col-12 lesson-content" style={{padding: "0px"}}  >
                                <div className='row'>
                                    <div className='col-md-12 mobile-header' >
                                        {this.props.coursePageclassInformation! ? (
                                            <div className="media mobile_display_course_name" style={{ marginTop: 'auto' }}>
                                                {
                                                    this.state.showMobile === false &&
                                                    // <SecureImage style={{ objectFit: 'cover', borderRadius: '50%' }}
                                                    //     height={45}
                                                    //     width={45}
                                                    //     imageUrl={this.props.coursePageclassInformation.logoUrl!}
                                                    //     key={this.props.coursePageclassInformation.logoUrl!}
                                                    //     class={'course-icon'}
                                                    //     imgType={'smallCourse'}
                                                    // />
                                                    <img className="course-icon"
                                                        style={{width:45,height:45,objectFit: 'contain',backgroundColor:'#efefef', borderRadius: '50%'}}
                                                        src={this.props.coursePageclassInformation.logoUrl!}
                                                        key={this.props.coursePageclassInformation.logoUrl!}
                                                        alt="Logo"
                                                        onError={(e) => {
                                                            e.currentTarget.onerror = null;
                                                            e.currentTarget.src = CourseLogo;
                                                            e.currentTarget.classList.add("default-logo");
                                                        }}
                                                        data-imgtype={'main'} />
                                                }

                                                <div
                                                    className="media-body flex-column "
                                                    style={{ display: 'flex' }}
                                                >
                                                    <div className={'float-left'}>
                                                        {this.props.coursePageclassInformation.courseName &&
                                                            <Tooltip className='course_name' data={this.props.coursePageclassInformation.courseName} position='bottom' >
                                                                <Truncater length={36} as='p' text={this.props.coursePageclassInformation.courseName}></Truncater>
                                                            </Tooltip>
                                                        }

                                                    </div>

                                                </div>

                                            </div>
                                        ) : (
                                            ''
                                        )}
                                        {
                                            (this.state.showMobile === true) &&
                                            <ScrollableMenu user={this.props.userType} tabOnClick={this.tabOnClick} courseContentMenuType={this.props.courseContentMenuType} refreshCourseContent={() => this.refreshCourseContent()}
                                                moduleItems = {this.props.moduleItems}
                                             />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row col-md-6 col-12 max-width-header">
                                <div className="col-md-12 col-6 lesson-tabs pr-0" >
                                    <div className="tab-header animated fadeIn display_m_none" id="myTab" role="tablist">
                                        <div>
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-secondary dropdown-toggle d-md-none mb-4"
                                                    type="button"
                                                    id="dropdownMenuButton"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    Menü
                                                </button>
                                                <div className="dropdown-menu lesson_content_navbar" aria-labelledby="dropdownMenuButton">
                                                    <ul className="nav nav-tabs" style={{ gap: '.5em' }} id="collapseExample">
                                                        <li className="nav-item bar_courseContent">
                                                            <a
                                                                onClick={this.tabOnClick}
                                                                className="nav-link"
                                                                data-tabparam={TabMenuItems.courseContent}
                                                                id="courseContent-tab"
                                                                data-toggle="tab"
                                                                href="#courseContent"
                                                                role="tab"
                                                            >
                                                                {T.t('r_lesson_homepage_courseContent')}
                                                            </a>
                                                        </li>
                                                        {
                                                            this.props.moduleItems.includes(ModuleItems.Announcement)
                                                            &&
                                                            <li className="nav-item bar_announcements">
                                                                <a
                                                                    onClick={this.tabOnClick}
                                                                    className="nav-link"
                                                                    id="courseAnnouncements-tab"
                                                                    data-toggle="tab"
                                                                    data-tabparam={TabMenuItems.announcements}
                                                                    href=""
                                                                    role="tab"
                                                                >
                                                                    {T.t('r_lesson_homepage_announcements')}
                                                                </a>
                                                            </li>
                                                        }
                                                        {
                                                            this.props.moduleItems.includes(ModuleItems.Activities_Forum)
                                                            &&
                                                            <li className="nav-item bar_discussion">
                                                                <a
                                                                    onClick={this.tabOnClick}
                                                                    className="nav-link"
                                                                    id="courseDiscussion-tab"
                                                                    data-toggle="tab"
                                                                    href=""
                                                                    data-tabparam={TabMenuItems.discussion}
                                                                    role="tab"
                                                                >
                                                                    {T.t('r_lesson_homepage_discussion')}
                                                                </a>
                                                            </li>
                                                        }
                                                        {this.props.userType !== UserType.Student ?
                                                            <li className="nav-item bar_files">
                                                                <a
                                                                    onClick={this.tabOnClick}
                                                                    className="nav-link other_files"
                                                                    id="courseFiles-tab"
                                                                    data-toggle="tab"
                                                                    href=""
                                                                    data-tabparam={TabMenuItems.files}
                                                                    role="tab"
                                                                >
                                                                    {T.t('r_lesson_homepage_files')}
                                                                </a>
                                                            </li> : ''
                                                        }
                                                        {this.props.userType !== UserType.Student ?
                                                            <li className="nav-item bar_studentList">
                                                                <a
                                                                    onClick={this.tabOnClick}
                                                                    className="nav-link"
                                                                    id="courseStudentList-tab"
                                                                    data-toggle="tab"
                                                                    href=""
                                                                    data-tabparam={TabMenuItems.studentList}
                                                                    role="tab"
                                                                >
                                                                    {T.t('r_lesson_homePage_studentList')}
                                                                </a>
                                                            </li>
                                                            : ''}

                                                        {this.props.userType !== UserType.Student ?
                                                            <li className="nav-item bar_processes">
                                                                <a
                                                                    onClick={this.tabOnClick}
                                                                    className="nav-link"
                                                                    id="courseProcesses-tab"
                                                                    data-toggle="tab"
                                                                    href=""
                                                                    data-tabparam={TabMenuItems.processes}
                                                                    role="tab"
                                                                >
                                                                    {T.t('r_lesson_homePage_processes')}
                                                                </a>
                                                            </li>
                                                            : ''}
                                                        <li className={this.props.userType === UserType.Student ?
                                                            'nav-item course_other_list course_other_list_none student_course_other_list_none' :
                                                            'nav-item course_other_list course_other_list_none'}
                                                            >
                                                            <div id='notification_tooltip' className="course_other_list_none">
                                                                <a><i className="material-icons" style={{ fontSize: '23px', marginTop: '0px', height: '26px', width: '25px' }}>reordered</i></a>
                                                                <UncontrolledPopover className="course_other_list_none" trigger="hover focus" placement="bottom" target="notification_tooltip">
                                                                    <PopoverBody
                                                                        className="scrollable-popoverbody course_other_list_none" style={{
                                                                            backgroundColor: '#fff',
                                                                            backgroundClip: 'padding-box',
                                                                            border: '1px solid rgba(0, 0, 0, 0.15)',
                                                                            borderRadius: '0.50rem',
                                                                            padding: '0.5rem 6px'
                                                                        }}>
                                                                        <div className="nav-item other_courseContent">
                                                                            <a
                                                                                onClick={this.tabOnClick}
                                                                                className="nav-link nav-link-popover"
                                                                                data-tabparam={TabMenuItems.courseContent}
                                                                                id="courseContent-tab"
                                                                                data-toggle="tab"
                                                                                href="#courseContent"
                                                                                role="tab"
                                                                            >
                                                                                {T.t('r_lesson_homepage_courseContent')}
                                                                            </a>
                                                                        </div>
                                                                        {
                                                                            this.props.moduleItems.includes(ModuleItems.Announcement)
                                                                            &&
                                                                            <div className="nav-item other_announcements">
                                                                                <a
                                                                                    onClick={this.tabOnClick}
                                                                                    className="nav-link nav-link-popover"
                                                                                    id="courseAnnouncements-tab"
                                                                                    data-toggle="tab"
                                                                                    data-tabparam={TabMenuItems.announcements}
                                                                                    href=""
                                                                                    role="tab"
                                                                                >
                                                                                    {T.t('r_lesson_homepage_announcements')}
                                                                                </a>
                                                                            </div>
                                                                        }

                                                                        {
                                                                            this.props.moduleItems.includes(ModuleItems.Activities_Forum)
                                                                            &&
                                                                            <div className="nav-item other_discussion">
                                                                                <a
                                                                                    onClick={this.tabOnClick}
                                                                                    className="nav-link nav-link-popover"
                                                                                    id="courseDiscussion-tab"
                                                                                    data-toggle="tab"
                                                                                    href=""
                                                                                    data-tabparam={TabMenuItems.discussion}
                                                                                    role="tab"
                                                                                >
                                                                                    {T.t('r_lesson_homepage_discussion')}
                                                                                </a>
                                                                            </div>
                                                                        }
                                                                        {this.props.userType !== UserType.Student ?
                                                                            <div className="nav-item other_files">
                                                                                <a
                                                                                    onClick={this.tabOnClick}
                                                                                    className="nav-link nav-link-popover"
                                                                                    id="courseFiles-tab"
                                                                                    data-toggle="tab"
                                                                                    href=""
                                                                                    data-tabparam={TabMenuItems.files}
                                                                                    role="tab"
                                                                                >
                                                                                    {T.t('r_lesson_homepage_files')}
                                                                                </a>
                                                                            </div> : ''
                                                                        }
                                                                        {this.props.userType !== UserType.Student ?
                                                                            <div className="nav-item other_studentList">
                                                                                <a
                                                                                    onClick={this.tabOnClick}
                                                                                    className="nav-link nav-link-popover"
                                                                                    id="courseStudentList-tab"
                                                                                    data-toggle="tab"
                                                                                    href=""
                                                                                    data-tabparam={TabMenuItems.studentList}
                                                                                    role="tab"
                                                                                >
                                                                                    {T.t('r_lesson_homePage_studentList')}
                                                                                </a>
                                                                            </div>
                                                                            : ''}

                                                                        {this.props.userType !== UserType.Student ?
                                                                            <div className="nav-item other_processes">
                                                                                <a
                                                                                    onClick={this.tabOnClick}
                                                                                    className="nav-link nav-link-popover"
                                                                                    id="courseProcesses-tab"
                                                                                    data-toggle="tab"
                                                                                    href=""
                                                                                    data-tabparam={TabMenuItems.processes}
                                                                                    role="tab"
                                                                                >
                                                                                    {T.t('r_lesson_homePage_processes')}
                                                                                </a>
                                                                            </div>
                                                                            : ''}
                                                                    </PopoverBody>
                                                                </UncontrolledPopover>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {this.props.userType && this.props.userType !== UserType.Student ? <ClassSelection /> : ''}

                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state: IAppState, ownProps: ICourseContentMenu): ICourseContentMenu => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICourseContentMenu = Object.assign({}, ownProps, {
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        coursePagefirstTwoTeachers: state.coursePage.coursePagefirstTwoTeachers,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        lessonHeaderIsLoaded: state.coursePage.lessonHeaderIsLoaded,
        userType: state.login.identitiy.userType,
        homePageSelectedTab: state.coursePage.homePageSelectedTab,
        activityFilters: state.coursePage.activityFilters,
        hasFilter: state.coursePage.hasFilter,
        termWeeksOnFilter: state.coursePage.termWeeksOnFilter,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        courseContentMenuLoading: state.coursePage.courseContentMenuLoading,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        activeTabGuid: state.coursePage.activeTabGuid,
        actId: state.coursePage.actId,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeekActivitiesLoading: state.coursePage.courseContentWeekActivitiesLoading,
        activityIdAfterAdd: state.coursePage.activityIdAfterAdd,
        deletedActivityId: state.coursePage.deletedActivityId,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        sort: state.coursePage.courseSortingKey,
        moduleItems: state.login.login.moduleItems
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        (next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId ||
            next.coursePage.coursePageClassId === prev.coursePage.coursePageActivityId) &&
        next.coursePage.coursePageclassInformation === prev.coursePage.coursePageclassInformation &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.coursePage.homePageSelectedTab === prev.coursePage.homePageSelectedTab &&
        next.login.login.moduleItems === prev.login.login.moduleItems ;
    return ret;
};

const CLessonPageHeader = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(LessonPageHeader);

export default CLessonPageHeader;
